import { render, staticRenderFns } from "./CrearVODForm.vue?vue&type=template&id=44627388&scoped=true&"
import script from "./CrearVODForm.vue?vue&type=script&lang=ts&"
export * from "./CrearVODForm.vue?vue&type=script&lang=ts&"
import style0 from "./CrearVODForm.vue?vue&type=style&index=0&id=44627388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44627388",
  null
  
)

export default component.exports